import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function RequireGuest({ children }: { children: React.ReactNode }) {
  const { guest, loading } = useAuth();
  const loc = useLocation();
  if (loading) return null;
  if (!guest) {
    return <Navigate to="/anmelden" replace state={{ from: loc.pathname + loc.search }} />;
  }
  return <>{children}</>;
}
